import { ContactKey } from '@folio/utils/customerDisplayName';
import { LifeBuoyIcon } from 'lucide-react';
import type { KorintModulesProductsConfig } from 'korint-sdk/react';

const policyHolderInvitationRole = ['DRIVER'];

export const garantiePlusAssistanceConfig = {
  display: {
    category: 'protection',
    icon: LifeBuoyIcon,
    badges: [],
  },
  productCustomPath: '',
  customerInformations: {
    fieldsConfig: [
      {
        key: 'lastName',
        type: 'text',
        contactKey: ContactKey.LAST_NAME,
      },
      {
        key: 'firstName',
        type: 'text',
        contactKey: ContactKey.FIRST_NAME,
      },
      {
        key: 'email',
        type: 'email',
      },
      {
        key: 'address',
        type: 'text',
      },
      {
        key: 'postCode',
        type: 'postcode',
        hideIfEmpty: true,
      },
      {
        key: 'city',
        type: 'text',
        hideIfEmpty: true,
      },
      {
        key: 'phoneNumber',
        type: 'tel',
      },
      {
        key: 'companyName',
        type: 'text',
        hideIfEmpty: true,
        contactKey: ContactKey.COMPANY_NAME,
      },
      {
        key: 'siret',
        type: 'text',
        hideIfEmpty: true,
      },
    ],
  },
  assetInformations: {
    fieldsConfig: [
      {
        key: 'registrationNumber',
        type: 'text',
      },
      {
        key: 'brand',
        type: 'text',
      },
      {
        key: 'model',
        type: 'text',
      },
      {
        key: 'version',
        type: 'text',
        hideIfEmpty: true,
      },
      {
        key: 'vinNumber',
        type: 'text',
        hideIfEmpty: true,
      },
      {
        key: 'vehicleFirstRegistrationDate',
        type: 'date',
        hideIfEmpty: true,
      },
      {
        key: 'fiscalPower',
        type: 'number',
      },
      {
        key: 'energy',
        type: 'text',
      },
      {
        key: 'vehicleMileage',
        type: 'number',
      },
      {
        key: 'vehicleType',
        type: 'text',
      },
      {
        key: 'latestPriceInEuro',
        type: 'number',
      },
    ],
  },
  claims: {
    claimsCategories: [
      {
        category: 'BODILY_HARM',
        label: 'Corporel',
        hasResponsibility: true,
      },
      {
        category: 'MATERIAL_DAMAGE',
        label: 'Matériel',
        hasResponsibility: true,
      },
      {
        category: 'THEFT',
        label: 'Vol',
      },
      {
        category: 'FIRE',
        label: 'Incendie',
      },
      {
        category: 'GLASS_BREAKAGE',
        label: 'Bris de glace',
      },
      {
        category: 'PARKED_DAMAGE',
        label: 'En stationnement',
      },
    ],
  },
  priceBreakdownConfig: {
    groups: [
      {
        lines: [
          { type: 'PRESET', key: 'total.withFeesPreTaxes' },
          { type: 'PRESET', key: 'total.taxes' },
        ],
      },
    ],
    totals: [{ type: 'PRESET', key: 'total.withFeesAndTaxes' }],
  },
  policyholderInvitationModuleConfig: {
    relationTypes: policyHolderInvitationRole,
  },
  policyDashboardEventsModuleConfig: {
    enableAssetComparison: false,
    enablePolicyComparison: false,
  },
  finalizeNewBusinessModuleConfig: { rules: [] },
} satisfies KorintModulesProductsConfig;
